export default __webpack_public_path__ + "static/media/tablelogo.d358cc16.png";